import React, { FC, useEffect, useState, useCallback } from 'react';

import { Table } from '@app/components/common/table/table';
import { useIsAdmin } from '@app/hooks/use-is-admin';
import { MailingItem } from '@app/api/models/admin';
import { useApi, useFetchData } from '@app/hooks';
import { TableColumn } from '@app/components/common/table';

import api from '../../api/api';
import { useColumns } from './columns';
import { useEntitiesState } from '../../hooks/use-entities-state';
import EditVar from './edit';
import Error404 from '../errors/404';

const RoutesTable: FC = () => {
  const isAdmin = useIsAdmin();
  const api = useApi();


  const [mailingLists, total, loading, setState] = useEntitiesState<MailingItem>();
  const [editOpen, setEditOpen] = useState(false);
  const [operatedList, setOperatedList] = useState<MailingItem>();

  const columns = useColumns({
    onEdit: (id: number) => {
      setOperatedList(mailingLists.find((item) => item.id === id));
      setEditOpen(true);
    },
  });

  const fetchData = useCallback(async () => {
    setState([], 0, true);
    const result = await api.admin.getMailingLists();
    setState(result.data || [], result.data?.length || 0, false);
  }, [api.service, setState]);


  useEffect(() => {
    if (!editOpen) {
      fetchData();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editOpen]);

  if (!isAdmin) {
    return <Error404/>;
  }

  return (
    <>
      <Table
        title="Email-рассылки"
        data={mailingLists}
        columns={columns}
        loading={loading}
      />
      <EditVar open={editOpen} setOpen={setEditOpen} mailingList={operatedList} />
    </>
  );
};

export default RoutesTable;
